import $ from 'jquery';
import React from 'react';
import QueryString from 'query-string';
import UserToken,{getUserLocation} from '../function_lib/userToken';
import {CallMapMethod,RespBkMthdMapp,AjaxCallMethod,GetImgCertUser,
    sortList,CallMapMethod_CBack} from '../function_lib/common_lib';
import {getRoleDetails,CallCMSMapMethod} from '../function_lib/common_cms';
import {Product_Listing,Vendor_Listing,Vendor_Listing_Horizontal} from '../sample_comp/product_listing';
import {Comp_Vendor_Listing} from '../sample_comp/comp_vendor_listing';
// import {Product_Listing_Cryst} from '../sample_comp/product_listing_cryst.js';
import Front_Header from './front_header';
import Footer from './footer';
import Top_Banner from '../sample_comp/top_banner';
import Top_Specified from './top_specified';
import Home_Product from './home_product';
import Product_Slider from '../sample_comp/product_slider';
import Features_Slider  from '../sample_comp/features_slider';
import Feature_Web_List from '../sample_comp/feature_web_list';
import {Article_Listing} from '../sample_comp/article_listing';
import Home_Banner from '../sample_comp/home_banner';
import Article_Blogs from '../sample_comp/article_blogs';
import Left_Img_Txt_Desc from '../sample_comp/left_img_txt_desc';
import Single_Img_Msg from '../sample_comp/single_img_msg';
import Txt_Description from '../sample_comp/txt_description';
import ImageGallery from '../sample_comp/image_gallery';
import Video_Slider from '../sample_comp/video_slider';
import Collapse_Pan from '../sample_comp/collapse_pan';
//import Feature_Card from '../sample_comp/feature_card';
import Image_Slider from '../sample_comp/image_slider';
import Feature_Card_n1 from '../sample_comp/feature_card_n1';

import { Player } from 'video-react';
// import AOS from 'aos';
import LogoImg from '../assets/images/my_logo.jpg';
import titleVid from '../assets/videos/imp_water.mp4';

//import titleVid from '../assets/images/backg.gif';
import './index.css';
/* Media */
import logoImg from '../assets/images/logo/logo.png';

import ban1 from '../assets/images/slider-image/02.jpg';
import ban2 from '../assets/images/slider-image/02.jpg';

//import pImg1 from '../assets/images/product-image/AsthmaticaOil.png'
import Left_Menu_Option from '../sample_comp/left_menu_option';
import Blogs from '../sample_comp/blogs';
import Time_Line from '../sample_comp/time_line';

import '../sample_comp/why_us.css';
import '../sample_comp/product_listing_cryst.css';

let loginUser="";
let userObject="";
let clsObject="";
let loc="";
let products="";
let rightBarLists;

let rf=0;
let queries;
let catNameLike="";

let _listProducts=[];
let _filters=[{"category_name":"Pathology - Laboratory","category_code":"1"},
{"category_name":"Radiology","category_code":"2"},
{"category_name":"Cardiology","category_code":"3"},
{"category_name":"Profile","category_code":"6"}];
// let _filters=[{"category_name":"BIOCHEMISTRY","category_code":"34"},
// {"category_name":"CLINICAL PATHOLOGY","category_code":"41"},
// {"category_name":"CYTOLOGY","category_code":"42"},
// {"category_name":"ENDOCRINOLOGY","category_code":"35"},
// {"category_name":"FLUIDS","category_code":"39"},
// {"category_name":"HAEMATOLOGY","category_code":"33"},
// {"category_name":"HISTOPATHOLOGY","category_code":"43"},
// {"category_name":"HORMONES","category_code":"36"},
// {"category_name":"IMMUNOLOGY","category_code":"37"},
// {"category_name":"MICROBIOLOGY","category_code":"40"},
// {"category_name":"SEROLOGY","category_code":"38"}];


let _locationSearch="";

class Vendor_List_Page extends React.Component{
    constructor(props){
        super(props);
        this.state={viewData:"0"};
        this.multiselectRef = React.createRef();
        loc=props.location["pathname"].substr(1);
        //alert(loc);
        if(props !=null){
            queries = QueryString.parse(this.props.location.search);
            if(queries.rf!=null){
              rf=queries.rf;
            }else{
                catNameLike=this.props.match.params.name;
            }
            
          }
        _locationSearch=getUserLocation();
        if(localStorage.getItem("userData")!=null){
          //alert(localStorage.getItem("userData"));
          UserToken.setUserObject(localStorage.getItem("userData"));
          userObject= UserToken.getUserObject();
         var listRoles= UserToken.getAccessRoles();
          if(userObject){
            //loginUser=userObject[0].person_name;
          }
          rightBarLists= getRoleDetails(listRoles,loc);
         
          //window.location.href="./Dashboard";
        }
      }

      getVendorListFilter(filters){
        //alert(JSON.stringify(filters));
        let map=[];
        if(rf!==0){
            map.push({name:"curl_type",value:"vendorsList"});
            map.push({name:"res_func",value:"callBackHospitals"});
            map.push({name:"sec",value:"27KeHNL8l225KpBePgi8Hg=="});
            map.push({name:"item_id",value:rf});
            map["res_func"]="callBackHospitals";
            map["curl_type"]="vendorsList";
            //CallMapMethod(clsObject,map);
        }else{
           
            if(catNameLike.toUpperCase()==="PATHOLOGY_LABORATORY"){
               // alert("I am in category");
                //map.push({name:"item_category_name",value:"laboratory"}); comment in case of filter

            }else if(catNameLike.toUpperCase()==="DIAGNOSTIC_CENTERS"){
                //map.push({name:"item_category_name",value:"radiology"}); comment in case of filter
            }
            else{
                map.push({name:"item_like",value:catNameLike});
            }
      }
      map.push({name:"filters",value:JSON.stringify(filters)});
      map.push({name:"user_location",value:_locationSearch});
      map["res_func"]="callBackHospitals";
      map["curl_type"]="vendorsList";
      
  CallMapMethod_CBack(clsObject,map,function(data,msg){
      //alert("from filer=="+data);
      //$("#mainRsp").html(msg);
      if(data!=="0"){
          _listProducts=JSON.parse(data);
          //alert(_listProducts.length);
      
        let resPs = Vendor_Listing_Horizontal(data,_filters,true,true);
          $("#pro_list_parent").html(resPs);
      }
  })
    }

      GetVendorList(){
        
        if(rf!==0){
            //alert("i m in vendorlist");
            var map=[];
            map.push({name:"curl_type",value:"vendorsList"});
            map.push({name:"res_func",value:"callBackHospitals"});
            map.push({name:"sec",value:"27KeHNL8l225KpBePgi8Hg=="});
            map.push({name:"item_id",value:rf});
            map.push({name:"online_apply",value:"1"});
            map.push({name:"home_apply",value:"1"});
            map.push({name:"user_location",value:_locationSearch});
            map["res_func"]="callBackHospitals";
            map["curl_type"]="vendorsList";
            CallMapMethod(clsObject,map,true);
        }else{
            //alert("i m inside ..");
            var map=[];
            map.push({name:"curl_type",value:"vendorsList"});
            map.push({name:"res_func",value:"callBackHospitals"});
            map.push({name:"sec",value:"27KeHNL8l225KpBePgi8Hg=="});
            map.push({name:"user_location",value:_locationSearch});
            if(catNameLike.toUpperCase()==="PATHOLOGY_LABORATORY"){
               // alert("I am in category");
                map.push({name:"item_category_name",value:"Pathology - Laboratory"});
            }else if(catNameLike.toUpperCase()==="DIAGNOSTIC_CENTERS"){
                //alert("i m in diagnostic")
                map.push({name:"item_category_name",value:"radiology"});
            }
            else{
                map.push({name:"item_like",value:catNameLike});
            }
            
            map["res_func"]="callBackHospitals";
            map["curl_type"]="vendorsList";
            CallMapMethod(clsObject,map,true);
        }
      }
    setSorting(val){
        //alert(val);
        if(val==="Price Low to High"){
            let jsData=sortList(_listProducts,"cost",true,true);
            let data=JSON.stringify(jsData);
            let strSearchPro=Vendor_Listing_Horizontal(data,[],true,true);
        $("#pro_list_parent").html(strSearchPro);
        }else if(val==="Price High to Low"){
            let jsData=sortList(_listProducts,"cost",false,true);
            let data=JSON.stringify(jsData);
            let strSearchPro=Vendor_Listing_Horizontal(data,[],true,true);
        $("#pro_list_parent").html(strSearchPro);
        }else if(val==="Brand"){

        }else if(val==="Name A – Z"){
            let jsData=sortList(_listProducts,"product_name",true,false);
            let data=JSON.stringify(jsData);
            let strSearchPro=Vendor_Listing_Horizontal(data,[],true,true);
        $("#pro_list_parent").html(strSearchPro);

        }else if(val==="Name Z – A"){
            let jsData=sortList(_listProducts,"product_name",false,false);
            let data=JSON.stringify(jsData);
            let strSearchPro=Vendor_Listing_Horizontal(data,_filters,true,true);
        $("#pro_list_parent").html(strSearchPro);
        }
    }  
       
     GetVendorList_Old(){
        //alert("i am in click")
        var map=[];
        map.push({name:"curl_type",value:"CheckBeds"});
        map.push({name:"res_func",value:"callBackHospitals"});
        map.push({name:"sec",value:"27KeHNL8l225KpBePgi8Hg=="});
        map.push({name:"state_id",value:"744"});
        map.push({name:"city_id",value:"3465"});
        map["res_func"]="callBackHospitals";
        map["curl_type"]="CheckBeds";
        CallMapMethod(clsObject,map);
      }
      callBackHospitals(data,msg){
        //   alert(data);
        //    $("#divMedi").html(msg);
        //    return;
          if(data!=="0"){
            _listProducts=JSON.parse(data);
             var vsList=Vendor_Listing_Horizontal(data,_filters,true);
            //var vsList=Product_Listing_Cryst(data);
             $("#divMedi").html(vsList);
             //$("#divMedi").html(msg);
             RespBkMthdMapp(clsObject,"_addToCart","setCartBk");
             RespBkMthdMapp(clsObject,"onchangeselect","setSorting");

             RespBkMthdMapp(clsObject,"hevent_flt_rightbar",function(filters){
                //alert(JSON.stringify(filters));
                clsObject.getVendorListFilter(filters);
              });

           
          }
      }
    

componentDidMount(){
  clsObject=this;
  if(loc===""){
    loc="home";
}

this.GetVendorList();
  this.callBackProList("-1","-1");
//   let mapData=[];
//   mapData.push({"g_title":"Blood Tests from Local Laboratories","title":"testing","col1":"Liver Function Test","col4":"img_f/liver.png",
//                  "e_id":"125"});
//                  mapData.push({"g_title":"Blod Test12","title":"testing12","col1":"Diabetes Test","col4":"img_f/glucose-meter.png",
//                  "e_id":"125"});
//                  mapData.push({"g_title":"Blod Test12","title":"testing12","col1":"Thyroid Test","col4":"img_f/endocrine.png",
//                  "e_id":"125"});
//                  mapData.push({"g_title":"Blod Test12","title":"testing12","col1":"Fullbody Test","col4":"img_f/body.png",
//                  "e_id":"125"});
               
//   var medicineFet=Feature_Card_n1(mapData);
// $("#medicine_fet").html(medicineFet);



var mapImgSlid=[];
mapImgSlid.push({"g_title":"Medicine","title":"testing","col1":"Surgicals","col4":"img_f/fe1.jpg",
"e_id":"125"});
mapImgSlid.push({"g_title":"Blod Test12","title":"testing12","col1":"Allopathy","col4":"img_f/fe2.jpg",
"e_id":"125"});
mapImgSlid.push({"g_title":"Blod Test12","title":"testing12","col1":"Homeopathy","col4":"img_f/fe3.jpg",
"e_id":"125"});


var featSld=Image_Slider(mapImgSlid);
$("#feSlider").html(featSld);
/*
  var mapCat=[];
  mapCat.push({name:"curl_type",value:"getProducts"});
  mapCat.push({name:"res_func",value:"callBackProList"});
  mapCat.push({name:"gb_token",value:"5e7hmtL7R0GU7zEBVhJZmrKx8Qb4xy-G_ihGPxqUtrGt5qMHlOaQK8ba1r-o7qKuAChRCIL0_Pilz1gStWW2Mg"});
  mapCat.push({name:"p1",value:"new arrivals"});
  mapCat.push({name:"p2",value:"0"});
 // mapCat.push({name:"emp_id",value:userObject[0].id});
  mapCat["res_func"]="callBackProList";
  mapCat["curl_type"]="getProducts";
  CallMapMethod(clsObject,mapCat);
  */
  AjaxCallMethod(clsObject,"okSuccCNOT");

  
  if(loc===""){
      loc="home";
  }
  //alert(loc);
  //loc="blogs_article"
   const script2 = document.createElement("script");
             script2.src = "/specific_listing.js";
             script2.async = true;
             document.body.appendChild(script2); 
  
}
callBackpgData(data,msg){
    //alert("testing of2 "+data);
    //$("#pgComp").html(data);
    var listObj= JSON.parse("{\"access\":"+data+"}");
    //alert("successfully parse");
    var mainHt="";
    if(loc==="home"){
       // mainHt+=Video_Banner_Comp();
    }

    var injextI=0;
    var injCondition=false;
    var ifImgGallery=false;
    
    var strTopBanner="";
    for(var _dlist=0;_dlist<50;_dlist++){
     
        if(listObj.access[_dlist]){
            if(listObj.access[_dlist].top_banner){
               // alert("I am in conditio");
               injCondition=true;
               strTopBanner=Top_Banner(listObj.access[_dlist].top_banner);
            }
            else if(listObj.access[_dlist].home_banner){
               // alert("i am in cond..");
               injCondition=true;
                mainHt+=Home_Banner(listObj.access[_dlist].home_banner);
            }else if(listObj.access[_dlist].dual_text_card){
                injCondition=true;
                //var dbs=render(){return(new Dual_Banner(listObj.access[_dlist].dual_text_card)};
               // mainHt+=Dual_Banner(listObj.access[_dlist].dual_text_card);
            }else if(listObj.access[_dlist].single_img_text){
                injCondition=true;
                mainHt+=Single_Img_Msg(listObj.access[_dlist].single_img_text);
            }else if(listObj.access[_dlist].img_text_desc_img_left){
                injCondition=true;
                mainHt+=Left_Img_Txt_Desc(listObj.access[_dlist].img_text_desc_img_left);
            }else if(listObj.access[_dlist].text_description){
                injCondition=true;
                //alert("i am in text");
                //alert(Txt_Description(listObj.access[_dlist].text_description));
                mainHt+=Txt_Description(listObj.access[_dlist].text_description);
            }else if(listObj.access[_dlist].list_slider){
                injCondition=true;
                mainHt+=Article_Blogs(listObj.access[_dlist].list_slider);
            }else if(listObj.access[_dlist].image_gallery){
                injCondition=true;
                ifImgGallery=true;
                mainHt+=ImageGallery(listObj.access[_dlist].image_gallery);
            }else if(listObj.access[_dlist].video_slider){
                //alert("I am in testing");
                injCondition=true;
                mainHt+=Video_Slider(listObj.access[_dlist].video_slider);
            }
            else if(listObj.access[_dlist].blogs){
                
                injCondition=true;
                mainHt+=Blogs(listObj.access[_dlist].blogs);
            }else if(listObj.access[_dlist].feature_web_list){
                injCondition=true;
                //alert("I am in feature "+listObj.access[_dlist].feature_web_list);
              //  mainHt+=Feature_Card(listObj.access[_dlist].feature_web_list);
            }else if(listObj.access[_dlist].article_listing){
                injCondition=true;
                //alert("I am in feature "+listObj.access[_dlist].feature_web_list);
                mainHt+=Article_Listing(listObj.access[_dlist].article_listing);
            }else if(listObj.access[_dlist].collapse_pan){
                injCondition=true;
                mainHt+=Collapse_Pan(listObj.access[_dlist].collapse_pan);
            }else if(listObj.access[_dlist].time_line){
                injCondition=true;
                mainHt+=Time_Line(listObj.access[_dlist].time_line);
            }
            if(injCondition){
                injextI++;
            }
            if(injextI==1){
                //alert("check in condi == "+loc)
                if(loc==="home"){
                    mainHt+=Features_Slider();
                    //alert(products);
                    mainHt+=products;
                }
           }
        }
        //$("#pgComp").innerHtml=mainHt;
    }
    //alert(mainHt);
    //mainHt+=Product_Hori_Slider();

    //Condition for leftMenuOpt
    if(rightBarLists){
        var getLeftOpt=Left_Menu_Option(rightBarLists,loc);
    var mainDiv="<div class=\"shop-category-area pb-100px pt-70px\">"+
    "<div class=\"container\">"+
        "<div class=\"row\">";
    var mainCloseDiv="</div></div></div>";
    mainHt="<div class=\"col-lg-9 order-lg-last col-md-12 order-md-first\">"+
            mainHt+"</div>";
    mainHt=mainDiv+getLeftOpt+mainHt+mainCloseDiv;
      }
   mainHt=strTopBanner+mainHt;

    $("#pgComp").html(mainHt);

   

    // AOS.init();
    // AOS.init({
    //   once: true
    // });
    const script = document.createElement("script");
    script.src = "/main.js";
    script.async = true;
    //script.onload = () => clsObject.scriptLoaded();
    document.body.appendChild(script);

   
      //this.forceUpdateHandler();
    if(ifImgGallery){
        $('.gallery-item').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    }
  
}
setCartBk(refId){
   // alert(refId);
    this.setState(state =>({viewData:refId}));
    this.forceUpdate();
    $("#offcanvas-cart").addClass("offcanvas-open");
  }
callBackProList(data,msg){
       //alert("testing=="+data);
    if(data!=="0"){
    // var resPs= Product_Slider(data);
   
    // products+=resPs;
    
    }
    //alert("i am in lcick");
    var pgMap=[];
  pgMap.push({name:"curl_type",value:"getPgData"});
  pgMap.push({name:"res_func",value:"callBackpgData"});
  pgMap.push({name:"loc",value:loc});
 // mapCat.push({name:"gb_token",value:userObject[0].app_user_id});
  //mapCat.push({name:"emp_id",value:userObject[0].id});
  pgMap["res_func"]="callBackpgData";
  pgMap["curl_type"]="getPgData";
  CallCMSMapMethod(clsObject,pgMap);
  }
saveEdu(){
  GetImgCertUser(clsObject,"#frmEdu","getTest","okEdut");
}
okEdut(data,datares,userResp){
  //alert(data);
}
    render(){
        return(<div>
        <div id="mainRsp"></div>
          <Front_Header/>

          <div className="offcanvas-overlay"></div>
          {/* <div className="product-catagories-wrapper py-3">
<div className="container">
  <div className="section-heading">
  <div className="card1 bg-warning mb-3">
<div className="card-body d-flex align-items-center">
  <div className="order-icon text-red"><i class="icon-arrow-down-circle"></i></div>
  <div className="order-status">Frequently Booked Test</div>
</div>
</div>
  </div>
  <div id="medicine_fet" className="product-catagory-wrap">

  </div>
 
</div>
</div> */}
<div id="feSlider"></div>
<Comp_Vendor_Listing/>
<div id="divMedi">

</div>
         <div id="pgComp">

         </div>
     
     {/* <section id="why-us" className="why-us pb-70px pt-10">
<div className="container">

  <div className="row">
    <div className="col-lg-4 d-flex align-items-stretch">
      <div className="content">
        <h3>Why Choose Advaiet?</h3>
        <p>
        our body is the best place to live. So, taking care of it shouldn’t be a difficult thing..
        </p>
        <div className="text-center">
          <a href="#" className="more-btn">Learn More <i className="bx bx-chevron-right"></i></a>
        </div>
      </div>
    </div>
    <div className="col-lg-8 d-flex align-items-stretch">
      <div className="icon-boxes d-flex flex-column justify-content-center">
        <div className="row">
          <div className="col-xl-4 d-flex align-items-stretch">
            <div className="icon-box mt-4 mt-xl-0">
            <i class="icon-arrow-right-circle" aria-hidden="true"></i>
              <h4>Natural is Good</h4>
              <p>Consequuntur sunt aut quasi enim aliquam quae harum pariatur laboris nisi ut aliquip</p>
            </div>
          </div>
          <div className="col-xl-4 d-flex align-items-stretch">
            <div className="icon-box mt-4 mt-xl-0">
            <i class="icon-arrow-right-circle" aria-hidden="true"></i>
              <h4>Concious for Health</h4>
              <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt</p>
            </div>
          </div>
          <div className="col-xl-4 d-flex align-items-stretch">
            <div className="icon-box mt-4 mt-xl-0">
            <i class="icon-arrow-right-circle" aria-hidden="true"></i>
              <h4>Rejuvenating your life</h4>
              <p>Aut suscipit aut cum nemo deleniti aut omnis. Doloribus ut maiores omnis facere</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</section> */}

          <Footer/>
          
          
          
          
          <div className="modal fade" id="exampleModal" tabindex="-1" role="dialog">
          <div className="modal-dialog" role="document">
              <div className="modal-content">
                  <div className="modal-header">
                      <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close"><span
                              aria-hidden="true">x</span></button>
                  </div>
                  <div className="modal-body">
                      <div className="row">
                          <div className="col-md-5 col-sm-12 col-xs-12 mb-lm-30px mb-sm-30px">
                              
                              <div className="swiper-container gallery-top mb-4">
                                  <div className="swiper-wrapper">
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/1.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/2.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/3.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/4.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/5.jpg" alt=""/>
                                      </div>
                                  </div>
                              </div>
                              <div className="swiper-container gallery-thumbs slider-nav-style-1 small-nav">
                                  <div className="swiper-wrapper">
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/1.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/2.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/3.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/4.jpg" alt=""/>
                                      </div>
                                      <div className="swiper-slide">
                                          <img className="img-responsive m-auto" src="assets/images/product-image/5.jpg" alt="" />
                                      </div>
                                  </div>
                                 
                                  <div className="swiper-buttons">
                                      <div className="swiper-button-next"></div>
                                      <div className="swiper-button-prev"></div>
                                  </div>
                              </div>
                          </div>
                          <div className="col-md-7 col-sm-12 col-xs-12">
                              <div className="product-details-content quickview-content">
                                  <h2>Originals Kaval Windbr</h2>
                                  <p className="reference">Reference:<span> demo_17</span></p>
                                  <div className="pro-details-rating-wrap">
                                      <div className="rating-product">
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                          <i className="ion-android-star"></i>
                                      </div>
                                      <span className="read-review"><a className="reviews" href="#">Read reviews (1)</a></span>
                                  </div>
                                  <div className="pricing-meta">
                                      <ul>
                                          <li className="old-price not-cut">$18.90</li>
                                      </ul>
                                  </div>
                                  <p className="quickview-para">Lorem ipsum dolor sit amet, consectetur adipisic elit eiusm tempor incidid ut labore et dolore magna aliqua. Ut enim ad minim venialo quis nostrud exercitation ullamco</p>
                                  <div className="pro-details-size-color">
                                      <div className="pro-details-color-wrap">
                                          <span>Color</span>
                                          <div className="pro-details-color-content">
                                              <ul>
                                                  <li className="blue"></li>
                                                  <li className="maroon active"></li>
                                              </ul>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="pro-details-quality">
                                      <div className="cart-plus-minus">
                                          <input className="cart-plus-minus-box" type="text" name="qtybutton" value="1" />
                                      </div>
                                      <div className="pro-details-cart btn-hover">
                                          <button className="add-cart btn btn-primary btn-hover-primary ml-4"> Add To
                                              Cart</button>
                                      </div>
                                  </div>
                                  <div className="pro-details-wish-com">
                                      <div className="pro-details-wishlist">
                                          <a href="wishlist.html"><i className="ion-android-favorite-outline"></i>Add to
                                              wishlist</a>
                                      </div>
                                      <div className="pro-details-compare">
                                          <a href="compare.html"><i className="ion-ios-shuffle-strong"></i>Add to compare</a>
                                      </div>
                                  </div>
                                  <div className="pro-details-social-info">
                                      <span>Share</span>
                                      <div className="social-info">
                                          <ul>
                                              <li>
                                                  <a href="#"><i className="ion-social-facebook"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-twitter"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-google"></i></a>
                                              </li>
                                              <li>
                                                  <a href="#"><i className="ion-social-instagram"></i></a>
                                              </li>
                                          </ul>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </div>
          </div>
          
          );
    }
}
export default Vendor_List_Page;